'use client';

import { memo } from 'react';

import { ASSET_CARD_METADATA_HEIGHT } from '~/components/gallery/GalleryAssetCard';

const DEFAULT_THUMBNAIL_HEIGHT = 150;
/** mt-2 top margin applied to the metadata container */
const METADATA_TOP_MARGIN = 8;

export type GalleryAssetSkeletonProps = {
  /** Thumbnail height in pixels. Defaults to 150px to match TARGET_ROW_HEIGHT. */
  thumbnailHeight?: number;
};

/**
 * Loading skeleton for gallery asset cards.
 * Matches the layout of GalleryAssetCard with thumbnail and metadata below.
 */
export const GalleryAssetSkeleton = memo(({ thumbnailHeight }: GalleryAssetSkeletonProps) => {
  return (
    <div className="flex size-full flex-col">
      {/* Thumbnail skeleton */}
      <div
        className="w-full animate-pulse rounded-12 bg-neutral-4"
        style={{ height: thumbnailHeight ?? DEFAULT_THUMBNAIL_HEIGHT }}
      />
      {/* Metadata skeleton */}
      <div className="mt-2 space-y-1" style={{ height: ASSET_CARD_METADATA_HEIGHT - METADATA_TOP_MARGIN }}>
        <div className="h-5 w-3/4 animate-pulse rounded bg-neutral-4" />
        <div className="h-3 w-1/2 animate-pulse rounded bg-neutral-4" />
      </div>
    </div>
  );
});

GalleryAssetSkeleton.displayName = 'GalleryAssetSkeleton';
